
import { Discipline } from './types';

export const humanitiesScience: Discipline = {
  id: 'humanitiesScience',
  name: 'Sciences',
  courses: [
    {
      id: 'humsci101',
      title: 'The Early Universe',
      instructor: 'Alan Guth',
      link: 'https://www.youtube.com/playlist?list=PLUl4u3cNGP61Bf9I0WDDriuDqEnywoxra',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=ANCN7vr9FVk&list=PLUl4u3cNGP61Bf9I0WDDriuDqEnywoxra',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/8-286-the-early-universe-fall-2013/'
        }
      ]
    },
    {
      id: 'humsci102',
      title: 'Evolution, Ecology and Behavior',
      instructor: 'Stephen Stearns',
      link: 'https://www.youtube.com/playlist?list=PL6299F3195349CCDA',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=VjgHd6HKtvE&list=PL6299F3195349CCDA',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/ecology-and-evolutionary-biology/eeb-122'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/evolution-ecology-and-behavior-audio/id341652737'
        }
      ]
    },
    {
      id: 'humsci103',
      title: 'Human Behavioral Biology',
      instructor: 'Robert Sapolsky',
      link: 'https://www.youtube.com/playlist?list=PL150326949691B199',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=NNnIGh9g6fA&list=PL150326949691B199',
      alternateLinks: [
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/human-behavioral-biology/id404310362'
        }
      ]
    },
    {
      id: 'humsci104',
      title: 'Darwin and Design',
      instructor: 'James Paradis',
      link: 'https://www.youtube.com/playlist?list=PLF7D7F81CD5E07497',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=fW4JKL0AFxA&list=PLF7D7F81CD5E07497',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/21l-448j-darwin-and-design-fall-2010/'
        }
      ]
    },
    {
      id: 'humsci105',
      title: 'Introduction to Psychology',
      instructor: 'Paul Bloom',
      link: 'https://www.youtube.com/playlist?list=PL6A08EB4EEFF3E91F',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=P3FKHH2RzjI&list=PL6A08EB4EEFF3E91F',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/introduction-psychology/psyc-110'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/psychology-audio/id341652042'
        }
      ]
    },
    {
      id: 'humsci106',
      title: 'Introduction to Psychology',
      instructor: 'John Gabrieli',
      link: 'https://www.youtube.com/watch?v=2fbrl6WoIyo&list=PL44ABC9278E2EE706',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=2fbrl6WoIyo&list=PL44ABC9278E2EE706',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/9-00sc-introduction-to-psychology-fall-2011/'
        }
      ]
    },
    {
      id: 'humsci107',
      title: 'The Human Brain',
      instructor: 'Nancy Kanwisher',
      link: 'https://www.youtube.com/playlist?list=PLUl4u3cNGP60IKRN_pFptIBxeiMc0MCJP',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=ba-HMvDn_vU&list=PLUl4u3cNGP60IKRN_pFptIBxeiMc0MCJP',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/9-13-the-human-brain-spring-2019/'
        }
      ]
    },
    {
      id: 'humsci108',
      title: 'The Psychology, Biology and Politics of Food',
      instructor: 'Kelly D. Brownell',
      link: 'https://www.youtube.com/playlist?list=PLh9mgdi4rNeyz0eiyC7pXr_20zPMi-tI9',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=TbUFwGGripI&list=PLh9mgdi4rNeyz0eiyC7pXr_20zPMi-tI9',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/psychology/psyc-123'
        }
      ]
    }
  ]
};
